import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import { ImpersonationStore } from 'shared';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [Tooltip, TranslatePipe],
  template: `
    @if (isImpersonating()) {
      <!-- Banner below topbar, full-width within layout-content-wrapper -->
      <div class="w-full h-10 bg-amber-100 border-b border-amber-200 z-30">
        <div class="flex items-center justify-between px-4 h-full">
          <!-- Icon: user icon -->
          <i class="pi pi-user text-amber-700 mr-2 text-lg"></i>

          <!-- User info with truncation and tooltip -->
          <div class="flex-1 min-w-0">
            <span
              class="text-amber-900 text-sm sm:text-base truncate block"
              [pTooltip]="fullUserInfo()"
              tooltipPosition="bottom"
              [showDelay]="300"
            >
              <span class="hidden sm:inline"
                >{{ 'layout.impersonation.viewingAs' | translate }}&nbsp;</span
              >
              <span class="font-medium">{{ userName() }}</span>
              <span class="hidden md:inline"> ({{ userEmail() }})</span>
            </span>
          </div>

          <!-- Exit button -->
          <button
            type="button"
            (click)="handleExit()"
            class="ml-4 text-amber-900 hover:text-amber-950 font-medium text-sm sm:text-base hover:underline focus:outline-none focus:underline"
            [attr.aria-label]="'layout.impersonation.exitAriaLabel' | translate"
          >
            {{ 'layout.impersonation.exit' | translate }}
          </button>
        </div>
      </div>
    }
  `,
})
export class ImpersonationBannerComponent {
  protected impersonationStore = inject(ImpersonationStore);

  protected isImpersonating = this.impersonationStore.isImpersonating;

  protected userName = computed(() => this.impersonationStore.impersonatedUser()?.name ?? '');

  protected userEmail = computed(() => this.impersonationStore.impersonatedUser()?.email ?? '');

  protected fullUserInfo = computed(() => {
    const user = this.impersonationStore.impersonatedUser();
    return user ? `${user.name} (${user.email})` : '';
  });

  protected handleExit(): void {
    // Calls endImpersonation() which navigates to /dashboard
    this.impersonationStore.endImpersonation();
  }
}
